module.exports = __webpack_public_path__ + "static/media/AstroBearLogo.01e33bef.png";